import React, { memo, useMemo, useRef } from 'react';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/tabs';
import { Documents } from './Documents';
import { Comments } from './Comments';
import { colors } from '../../../../../../theme/colors';

import { IClientDemand, IContent } from 'types/demands';

interface IProps {
  files: IClientDemand['solicitacaoDocumentos'];
  docs: IClientDemand['solicitacaoDocumentos'];
  clientName?: string;
  date?: string;
  updateFiles?: React.Dispatch<React.SetStateAction<IContent[] | undefined>>;
}

const FooterTabsComponent: React.FC<IProps> = ({ files, clientName, date, updateFiles, docs }) => {
  const dt = useMemo(() => date?.replaceAll('-', '/'), [date]);
  const dateRef = useRef(dt);
  if (date) {
    const dt = date.replaceAll('-', '/');
    dateRef.current = new Date(dt).toLocaleDateString();
  }
  return (
    <Tabs defaultIndex={0}>
      <TabList
        paddingTop="20px"
        borderBottom={'1px solid #5a646e !important'}
        borderTop={'1px solid #E9EBEE !important'}
      >
        <Tab
          _selected={{
            color: colors.brand.tertiary,
            borderColor: colors.brand.tertiary,
            fontWeight: 700,
          }}
        >
          Comentários
        </Tab>
        <Tab
          _selected={{
            color: colors.brand.tertiary,
            borderColor: colors.brand.tertiary,
            fontWeight: 700,
          }}
        >
          Documentos
        </Tab>
        {/* <Tab>Versões</Tab> */}
      </TabList>

      <TabPanels>
        <TabPanel p={'20px 0 10px 0'} borderTop={'1px solid #5A646E'} marginTop={'1.5rem'}>
          <Comments updateFiles={updateFiles} files={docs} />
        </TabPanel>

        <TabPanel>
          <Documents date={dateRef.current} clientName={clientName} files={files} />
          {/* <Pagination pagesCount={4} /> */}
        </TabPanel>

        <TabPanel>{/* <Versions /> */}</TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export const FooterTabs = memo(FooterTabsComponent);
